import { useCallback, useState } from "react";
import { FormInstance } from "antd";
import AutoChargesService from "../../../../../../../services/processing/autoCharges";
import dayjs from "../../../../../../../configs/dayjs";
import { useOpenProgressModal } from "../../../../../../../lib/hooks/useOpenProgressModal";
import { useAppDispatch } from "../../../../../../../store";
import { setErrorMessage } from "../../../../../../../acions/actionsCreators/messageActions";

export const useRunAutoCharge = (batchId: string, form: FormInstance, close: () => void, onSuccess: () => void) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { openModal } = useOpenProgressModal(
    "Creating AutoCharges",
    "Creating Autocharges failed",
    onSuccess,
    undefined,
    undefined,
    {
      errorMessageClosable: true
    }
  );

  const onApply = useCallback(() => {
    setIsLoading(true);

    const dateRange = form.getFieldValue("date");

    const request = {
      beginDate: dayjs(dateRange[0]).startOf("D").format(),
      endDate: dayjs(dateRange[1]).startOf("D").format()
    };

    AutoChargesService.create(batchId, request)
      .then((res) => {
        openModal(res);
        setIsLoading(false);
        close();
      })
      .catch((e: any) => {
        dispatch(setErrorMessage(e.response.data.title, true));
        setIsLoading(false);
        close();
      });
  }, [batchId, close, dispatch, form, openModal]);

  return { onApply, isLoading };
};
